export function removeYourFromLabel(label: string): string {
  return label.replaceAll('your', 'their');
}

export default removeYourFromLabel;
